const FREEZER_CONTAINERS = ['freezer_contents', 'freezer_door_contents'];
const FRIDGE_CONTAINERS = [
  'fridge_level_contents',
  'fridge_door_contents',
  'crisper_left_contents',
  'crisper_right_contents',
];
const PANTRY_LIKE_CONTAINERS = ['pantry_contents', 'other_contents'];
const SPICE_RACK_CONTAINER = 'spice_rack_contents';

function formatDate(date) {
  return date.toISOString().slice(0, 10);
}

function addDays(date, days) {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
}

function addMonths(date, months) {
  const nextDate = new Date(date);
  nextDate.setMonth(nextDate.getMonth() + months);
  return nextDate;
}

// function parseExpirationDate(expirationDate) {
//   if (!expirationDate) {
//     return new Date();
//   }

//   const parsedDate = new Date(expirationDate);
//   return Number.isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
// }

export function getAdjustedExpirationDate(
  sourceContainerKey,
  destinationContainerKey,
  currentExpirationDate
) {
  const today = new Date();

  if (FREEZER_CONTAINERS.includes(destinationContainerKey)) {
    return formatDate(addMonths(today, 2));
  }

  if (destinationContainerKey === SPICE_RACK_CONTAINER) {
    return formatDate(addDays(today, 365));
  }

  const movingOutOfLongTermStorage =
    FREEZER_CONTAINERS.includes(sourceContainerKey) ||
    sourceContainerKey === SPICE_RACK_CONTAINER;

  if (movingOutOfLongTermStorage && FRIDGE_CONTAINERS.includes(destinationContainerKey)) {
    return formatDate(addDays(today, 2));
  }

  if (movingOutOfLongTermStorage && PANTRY_LIKE_CONTAINERS.includes(destinationContainerKey)) {
    return formatDate(addDays(today, 1));
  }

  return currentExpirationDate;
}

export function shouldDeleteForQuantity(quantity) {
  const parsedQuantity = Number.parseFloat(quantity);

  if (Number.isNaN(parsedQuantity)) {
    return false;
  }

  return parsedQuantity <= 0;
}
